import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

import NotFound from './routes/NotFound';
import CCPAForm from './routes/CCPAForm';

import 'normalize.css';
import './App.scss';

/*
const validTDARoutes = [
  '/bos',
  '/cat',
  '/chi',
  '/cin',
  '/con',
  '/dvr',
  '/gny',
  '/goc',
  '/gst',
  '/inw',
  '/kac',
  '/nca',
  '/phx',
  '/ptl',
  '/set',
  '/snd',
  '/soc',
  '/tre',
  '/tri',
  '/ust',
  '/wwn',
]
*/
function App() {
  return (
    <Router>
      <Switch>
        <Route path="/:tdaContext" render={(route) => <CCPAForm tdaContext={route.match.params.tdaContext} />} />
        <Route path="*">
          <NotFound />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
